import { render, staticRenderFns } from "./KabContent.vue?vue&type=template&id=18177fbc&scoped=true&"
import script from "./KabContent.vue?vue&type=script&lang=js&"
export * from "./KabContent.vue?vue&type=script&lang=js&"
import style0 from "./KabContent.vue?vue&type=style&index=0&id=18177fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18177fbc",
  null
  
)

export default component.exports